import { makeAutoObservable } from "mobx";

const normalizeAnchorEl = (anchorEl) => {
  if (!anchorEl) return null;
  if (anchorEl.scrollLeft !== undefined && anchorEl.getBoundingClientRect) {
    return anchorEl;
  }
  if (anchorEl._component) return anchorEl._component;
  const node = anchorEl.getNode?.();
  if (node) return node;
  return anchorEl;
};

const resolveClientFromExercise = (exercise) => {
  return (
    exercise?.workout?.block?.client ??
    exercise?.block?.client ??
    exercise?.workout?.client ??
    exercise?.client ??
    null
  );
};

class ExerciseHistoryStore {
  isOpen = false;
  exercise = null;
  client = null;
  anchorEl = null;

  constructor() {
    makeAutoObservable(this);
  }

  openHistory({ exercise, client = null, anchorEl = null } = {}) {
    if (!exercise) return;

    const nextId = exercise?.id ?? null;
    const currentId = this.exercise?.id ?? null;

    if (
      this.isOpen &&
      nextId != null &&
      currentId != null &&
      String(nextId) === String(currentId)
    ) {
      this.closeHistory();
      return;
    }

    this.exercise = exercise;
    this.client = client ?? resolveClientFromExercise(exercise);
    this.isOpen = true;
    this.anchorEl = normalizeAnchorEl(anchorEl) ?? this.anchorEl;
  }

  closeHistory() {
    this.isOpen = false;
    this.anchorEl = null;
  }

  updateAnchor(exerciseId, anchorEl) {
    if (!this.isOpen) {
      this.anchorEl = null;
      return;
    }

    const currentId = this.exercise?.id ?? null;
    if (
      exerciseId != null &&
      currentId != null &&
      String(exerciseId) !== String(currentId)
    ) {
      return;
    }

    if (!anchorEl) return;
    const nextAnchor = normalizeAnchorEl(anchorEl);
    if (nextAnchor && nextAnchor !== this.anchorEl) {
      this.anchorEl = nextAnchor;
    }
  }

  reset() {
    this.isOpen = false;
    this.exercise = null;
    this.client = null;
    this.anchorEl = null;
  }
}

const exerciseHistoryStore = new ExerciseHistoryStore();

export const openExerciseHistory = (payload) => {
  exerciseHistoryStore.openHistory(payload);
};

export const closeExerciseHistory = () => {
  exerciseHistoryStore.closeHistory();
};

export const updateExerciseHistoryAnchor = (exerciseId, anchorEl) => {
  exerciseHistoryStore.updateAnchor(exerciseId, anchorEl);
};

export default exerciseHistoryStore;
